import { tbContainer } from "./tbContainer";
import { tbImage } from "./tbImage";
import { tbSpine } from "./tbSpine";
import { tbSpriteAnimation } from "./tbSpriteAnimation";
import { tbVectorFont } from "./tbVectorFont";
export function getPIXIObjectFromTbObject(obj) {
    var pixiObj;
    if (obj instanceof tbImage) {
        if (obj.sprite) {
            pixiObj = obj.sprite;
        }
    }
    else if (obj instanceof tbSpine) {
        if (obj.animation) {
            pixiObj = obj.animation;
        }
    }
    else if (obj instanceof tbContainer) {
        if (obj.container) {
            pixiObj = obj.container;
        }
    }
    else if (obj instanceof tbVectorFont) {
        if (obj.font) {
            pixiObj = obj.font;
        }
    }
    else if (obj instanceof tbSpriteAnimation) {
        if (obj.animation) {
            pixiObj = obj.animation;
        }
    }
    else {
        pixiObj = obj;
    }
    return pixiObj;
}
